import { useCallback, useState } from "react";
import { updateEmisionStep } from "../../../../Services/API/updateEmisionStep";
import { Cotizacion } from "../../../../Pages/Auto/Precios";
import { useEmisionStore } from "../../../../Services/Providers/EmisionStore";
import { useGraciasStore } from "../../../../Services/Providers/GraciasStore";
import { useNavigate, useParams } from "react-router-dom";
import { useConfiguracionEmpresa } from "../../../../Services/Providers/useConfiguracionEmpresa";
import { getPathName } from "../../../../Services/API/helper";

interface Props {
    rubro: string;
    cotizacion: Cotizacion;
    styles?: React.CSSProperties;

}

export const ButtonContratar = ({ rubro, cotizacion, styles = {} }: Props) => {

    const { emisionValues, setEmisionValues } = useEmisionStore();
    const { setGraciasValues } = useGraciasStore();
    const { origen, config } = useConfiguracionEmpresa();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const { compania } = useParams();

    const setDescription = () => {
        const nuevaDesc: any = {
            id: cotizacion.id,
            amountMonth: cotizacion.premio,
            companyLogo: cotizacion.LogoCompania,
            companyName: cotizacion.NombreCompania,
            codCompany: cotizacion.CodigoCompania,
            descList: cotizacion.descripciones,
            discountAmount: cotizacion.PrecioSinDescuento,
            discountPerc: cotizacion.DescuentoPorcentaje,
            fiscalInfoImg: cotizacion.Afip,
            nombreCompania: cotizacion.NombreCompania,
            planName: cotizacion.nombreCobertura,
            sumaAsegurada: cotizacion.SumaAsegurada
        };
        setEmisionValues({
            ...emisionValues,
            cotizacionDesc: nuevaDesc,
        });
    };

    const handleClick = async (e: any, direccion: string, gracias: boolean = false) => {
        e.preventDefault();
        if (isLoading) return
        setIsLoading(true)
        //document.body.style.cssText = "";

        await updateEmisionStep(0, {
            idItemCotizacion: cotizacion.id
        } as any)

        setDescription();
        setIsLoading(false)
        if (gracias) {
            setGraciasValues(cotizacion.NombreCompania)
        }
        navigate(direccion);
    }


    return (
        <>
            {(cotizacion?.id === null || origen !== "SEGURARSE")
                ?
                <a
                    href={compania ? (`/${rubro.toLocaleLowerCase()}/gracias/` + compania) : `/${rubro.toLocaleLowerCase()}/gracias/`}
                    type="button"
                    onClick={(e) =>
                        handleClick(e, (compania ? (`/${rubro.toLocaleLowerCase()}/gracias/` + compania) : `/${rubro.toLocaleLowerCase()}/gracias/`), true)
                    }
                    className="btn btn-primary fs-16"
                    style={origen !== "SEGURARSE" ? { ...styles, backgroundColor: config.colors.primary } : styles}>
                    <span>{"CONTRATAR "}</span>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm " role="status">
                            <span className="sr-only" />
                        </div>
                    }
                </a>
                :
                <>
                    {process.env.REACT_APP_EMISION_TEST === "true" ?
                        <a
                            href={`/${rubro.toLocaleLowerCase()}/emision/revision`}
                            type="button"
                            className="btn btn-primary fs-16"
                            onClick={(e) => handleClick(e, `/${rubro.toLocaleLowerCase()}/emision/revision`)}
                            style={{ ...styles }}
                        >
                            <span>{"CONTRATAR "}</span>
                            {isLoading &&
                                <div className="spinner-border spinner-border-sm " role="status">
                                    <span className="sr-only" />
                                </div>
                            }
                        </a> : <a
                            href={`${getPathName() + process.env.REACT_APP_URL_EMISION}${cotizacion.NombreCompania}/${cotizacion.id}${process.env.REACT_APP_URL_PREFIX}`} className="btn btn-primary fs-16" >
                            {"CONTRATAR"}
                        </a>}
                </>
            }
        </>
    )
}
